import { PlanDetail } from "../Pages/PlanDetail/PlanDetail";
import {
  ProductPage, Cart, VerifyNumber, SignUp, Marketplace, Login, Checkout,
  Order, BundleDescriptionScreen, OrderDetail, Account, FleekTab, BundleScreen, OrderConfirmation, MarketplaceUniquePlans,
  Orders, Support, DeleteAccount, CategoryPage, GiftClaim, Stores, Connect
} from "../Pages";

import { Routes, Route, Outlet, Navigate, useParams } from "react-router-dom";
import { cleanMarket, isIndia } from "../utils/market";

// A country store's own pages: /us (its home), /us/category/ai-tools and
// /us/brand/steam (utils/market.js readMarketPath opens that store). Anything
// else in that first segment (/in/..., /xx/...) is India's page of the same
// name, without the prefix.
const isStoreCode = (country) => {
  const code = cleanMarket(country);
  return /^[a-z]{2}$/i.test(country || "") && !!code && code !== "IN";
};

const StoreBrand = () => {
  const { country, vendor_name } = useParams();
  if (!isStoreCode(country)) return <Navigate to={`/brand/${vendor_name}`} replace />;
  return <PlanDetail />;
};

const StoreCategory = () => {
  const { country } = useParams();
  const { slug } = useParams();
  if (!isStoreCode(country)) return <Navigate to={`/category/${slug}`} replace />;
  return <CategoryPage country={country.toUpperCase()} />;
};

// A single unknown segment (/foo) is no store's home: the store, as before.
const StoreHome = ({ isLoggedIn }) => {
  const { country } = useParams();
  if (!isStoreCode(country)) return <Navigate to="/marketplace" replace />;
  return <Marketplace isLoggedIn={isLoggedIn} country={country.toUpperCase()} />;
};


export const WebSiteRoutes = ({ isLoggedIn }) => {
  const access_token = localStorage.getItem('accesstoken')
  return (
    <Routes>
      <Route path="brand" element={<Outlet />} >
        <Route path=":vendor_name" element={<PlanDetail />} />
        <Route path="" element={<Navigate to="/marketplace" />} />
      </Route>
      {/* A store's own brand page, /us/brand/steam (utils/market.js readMarketPath). */}
      <Route path=":country/brand/:vendor_name" element={<StoreBrand />} />
      <Route path=":country/category/:slug" element={<StoreCategory />} />
      <Route path=":country" element={<StoreHome isLoggedIn={isLoggedIn} />} />
      <Route path="category" element={<Outlet />} >
        <Route path=":slug" element={<CategoryPage />} />
        <Route path="" element={<Navigate to="/marketplace" />} />
      </Route>
      {/* Bundles are rupee offers: India's store only; elsewhere they're "coming soon" on the marketplace. */}
      <Route path="bundle" element={isIndia() ? <Outlet /> : <Navigate to="/marketplace" replace />} >
        <Route path=":bundle_id" element={<BundleDescriptionScreen isLoggedIn={isLoggedIn} />} />
        <Route path="" element={<BundleScreen isLoggedIn={isLoggedIn} />} />
      </Route>
      <Route path="product" element={<Outlet />} >
        <Route path=":product_id" element={<ProductPage />} />
      </Route>
      <Route path="cart" element={<Cart />}>
      </Route>
      <Route path="checkout" element={<Checkout />} />

      {
        !access_token &&
        <Route path="login" element={<Outlet />} >
          <Route path="verify-user" element={<VerifyNumber />} />
          <Route path="" element={<Login />} />
        </Route>
      }
      <Route path="order" element={<Order />} />
      <Route path="order-confirmation" element={<OrderConfirmation />} />
      <Route path="signup" element={<SignUp />} />
      <Route path="/" element={<Marketplace isLoggedIn={isLoggedIn} />} />
      <Route path="marketplace" element={<Marketplace isLoggedIn={isLoggedIn} />} />
      <Route path="marketplace/uniquely-available-plans/:keyword" element={<MarketplaceUniquePlans isLoggedIn={isLoggedIn} />} />
      <Route path="orderdetail" element={<Outlet />} >
        <Route path=":order_id" element={<OrderDetail />} />
      </Route>
      <Route path="account" element={<Account />} />
      <Route path="myorder" element={<Orders />} />
      <Route path="gift/:token" element={<GiftClaim />} />
      <Route path="connect" element={<Connect />} />
      <Route path="support" element={<Support />} />
      <Route path="stores" element={<Stores />} />
      <Route path="delete-account" element={<DeleteAccount />} />

      <Route path="fleektab" element={<FleekTab />} />
      <Route
        path="*"
        element={<Navigate to="/marketplace" />}
      />

    </Routes>
  );
};